<template>
	<div class="home-business">
		<btn-edit
			v-if="editable"
			class="top-responsive"
			@edit-section="openModal" />
		<div class="app-wrapper">
			<h2 class="home-business-title">Nuestros Productos</h2>
			<p v-if="false" class="home-business-subtitle">Es una Compañía Ecuatoriana fundada en 1982; la cual fue adquirida por ARIS INDUSTRIAL en el año 2015.</p>
			<div class="home-business__slider">
				<div class="home-business__slider__buttons">
					<button
						class="button button--prev"
						:disabled="isDisabled('prev')"
						@click="sliderTriggerPrev">
						<img
							height="20"
							src="/static/img/arrow-left.svg"
							alt="Anterior" />
					</button>
					<button
						class="button button--next"
						:disabled="isDisabled('next')"
						@click="sliderTriggerNext">
						<img
							height="20"
							src="/static/img/arrow-right.svg"
							alt="Siguiente" />
					</button>
				</div>
				<slider
					ref="slider-products"
					@slide="updateCurrentSlide"
					:options="options">
					<slideritem
						class="home-business__slide"
						v-for="(deal, index) in categories"
						:key="`slider-${index}`">
						<router-link
							class="slide__wrapper"
							:to="`/productos?id=${deal.id}`">
							<figure>
								<img
									class="slide__image"
									:src="deal.image"
									alt=""/>
								<figcaption>
									<h3 class="slide__title">{{deal.title}}</h3>
									<p class="slide__description">{{deal.description}}</p>
								</figcaption>
							</figure>
						</router-link>
					</slideritem>
				</slider>
			</div>
		</div>
		<edit-modal v-show="showModal">
			<category-form
				@close-modal="closeModal"
				@update-categories="updateCategories"
			/>
		</edit-modal>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { slider, slideritem } from 'vue-concise-slider';
import btnEdit from '@/components/commons/btn-edit';
import editModal from '@/components/commons/edit-modal';
import uploadImage from '@/components/commons/upload-image';
import categoryForm from '@/components/commons/category-form';

const components = {
	slider,
	slideritem,
	btnEdit,
	categoryForm,
	editModal,
	uploadImage,
};

const computed = {
	options() {
		return {
			currentPage: 0,
			infinite: 1,
			slidesToScroll: 1,
			loop: true,
			pagination: false,
			freeze: true,
		};
	},
};

const methods = {
	openModal() {
		this.showModal = true;
	},
	closeModal() {
		this.showModal = false;
	},
	updateCategories(newCategories) {
		this.categories = [...newCategories];
	},
	goToProductsFilterByCategory(category) {
		this.$router.push({ name: 'page-product', query: { id: category.id } });
	},
	sliderTriggerPrev: throttle(function () {
		this.$refs['slider-products'].$emit('slidePre');
	}, 500),
	sliderTriggerNext: throttle(function () {
		this.$refs['slider-products'].$emit('slideNext');
	}, 500),
	updateCurrentSlide(slide) {
		const { currentPage } = slide;
		this.currentSlide = currentPage;
	},
	isDisabled(direction) {
		const { categories, currentSlide } = this;

		if (direction === 'prev') {
			return currentSlide === 0;
		}

		return currentSlide + 4 === categories.length;
	},
};

function showModal(value) {
	this.onModal(value);
}

function mounted() {
	console.log(this.categories);
}

function data() {
	return {
		categories: [],
		checked: false,
		newCategory: {
			description: '',
			id: 0,
			image: '',
			title: '',
		},
		inner: window.innerWidth,
		showModal: false,
		currentSlide: 0,
	};
}

export default {
	name: 'section-business',
	data,
	components,
	computed,
	mounted,
	methods,
	watch: {
		showModal,
	},
};
</script>

<style lang="scss" scoped>
.home-business {
	background: map-get($colors, black-dark);
	padding: 80px 0;
	position: relative;

	&__slide {
		margin-right: 2%;
		width: 23.5%;
	}

	&__slider {
		position: relative;

		&__buttons {
			position: absolute;
			top: 50%;
			width: 100%;
			z-index: 10;

			.button {
				@include border-radius(50%);
				@include display-flex();
				@include transform(translateY(-50%));
				align-items: center;
				justify-content: center;
				position: absolute;
				background-color: #f5f5f5;
				height: 40px;
				width: 40px;

				&:disabled {
					@include opacity(.25);
					cursor: not-allowed;
				}
			}

			.button--prev {
				left: -60px;
			}

			.button--next {
				right: -60px;
			}
		}
	}
}

.slide {
	&__wrapper {
		background-color: #f5f5f5;
		display: block;
		width: 100%;
		overflow: hidden;

		figcaption {
			@include transition(box-shadow .3s linear 0s);
			@include box-shadow(0, 0, 13px, 1px, rgba(0, 97, 130, .3));
			background-color: #fff;
			color: map-get($colors, main);
			padding: 10px 0;
			position: relative;
			z-index: 2;
		}

		&:hover {
			figcaption {
				@include box-shadow(0, -2px, 13px, 2px, rgba(0, 97, 130, .5));
			}

			.slide__image {
				@include transform(scale(1.15));
			}

			.slide__title {
				@include transform(translateY(0));
			}

			.slide__description {
				@include opacity(1);
			}
		}
	}

	&__image {
		@include transition(transform .3s linear 0s);
		display: block;
		height: 250px;
		object-fit: cover;
		width: 100%;
		z-index: 1;
		position: relative;
	}

	&__title {
		@include transition(transform .3s linear 0s);
		@include transform(translateY(50%));
		@include font-size(18);
		@include font-maison-bold-italic();
		line-height: normal;
		margin-bottom: 3px;
	}

	&__description {
		@include transition(opacity .3s linear 0s);
		@include font-size(12);
		@include opacity(0);
		line-height: normal;
		width: 100%;
		padding: 0 5px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}

.home-business-title {
	@include font-maison-demi();
	@include font-size(24);
	color: map-get($colors, white);
	margin-bottom: 40px;
	text-align: center;
}

.home-business-subtitle {
	@include font-asap-regular();
	@include font-size(16);
	color: map-get($colors, white);
	line-height: normal;
	margin-bottom: 60px;
	text-align: center;
}

.business-sliders{
	height: 359px;
	margin: auto;
}

.title-section {
	@include font-maison-bold();
	@include font-size(20);
	color: map-get($colors, white);
	margin: 0px 54px 40px 54px;
	text-align: center;
}

.container-section {
	background-color: map-get($colors, sky-blue-medium);
	height: 450px;
	padding: 34px 35px;
}

.card {
	@include box-shadow(4px, 3px, 13px, 0, rgba(0, 97, 130, 0.6));
	transition: 0.3s;
}

.slider-description {
	background-color: map-get($colors, white);
	padding: 15px 10px;
}

.description-title {
	@include font-maison-bold-italic();
	@include font-size(17);
	color: map-get($colors, main);
	margin-bottom: 8px;
	margin-top: 5px;
}

.description-paragraph {
	@include font-maison-light();
	@include font-size(9);
	clear: left;
	color: map-get($colors, text);
	line-height: 14px;
	margin: 11px 0px 10px 0px;
	text-align: justify;
}

.business-sliders {
	position: relative;
}

.slider {
	margin-right: 5px;
}

.slider-hover {
	background: rgba(1, 18, 30, 0.53);
	height: 100%;
	margin: auto;
	opacity: 0;
	transition: 1s;
	width: 100%;
}

.hover-color {
	@include font-size(9);
	@include font-maison-bold-italic();
	color: map-get($colors, white);
	left: 20%;
	margin: auto;
	position: absolute;
	top: 35%;
}

@media (max-width: 968px) {
	.business-sliders {
		max-width: 268px;
		width: 100%;
	}
}

@media (max-width: 1292px) and (min-width:968px) {
	.business-sliders {
		width: 874px;
	}

	.slider:hover {
		border-bottom: 4px solid map-get($colors, red-dark);
		transition: 1s;

		.slider-hover {
			display: block;
			opacity: 1;
		}
	}
}

@media (min-width: 1292px) {
	.business-sliders {
		width: 77%;
	}

	.slider:hover {
		border-bottom: 4px solid map-get($colors, red-dark);
		transition: 1s;

		.slider-hover {
			@include opacity(1);
			display: block;
		}
	}
}

@media screen and (max-width: 600px) {
	.home-business {
		padding: 40px 0;

		&__slide {
			margin-right: 0;
			width: 100%;
		}

		&__slider {

			&__buttons {
				.button--prev {
					left: 10px;
				}

				.button--next {
					right: 10px;
				}
			}
		}
	}

	.home-business-subtitle {
		margin-bottom: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/home/business.vue